import Vue from 'vue'
import App from './App.vue'
import router from './router'
import bus from '@/utils/Bus'
import '@/style/index.scss'
import '@/common/antComponent.js'
import i18n from '@/lang/index'
import 'viewerjs/dist/viewer.css'
import {loadStyle} from '@/utils/customStyle';
import store from './vuex'
import { signObj } from "./utils/sign_.js";
Vue.prototype.signObj = signObj;



// loadStyle()

Vue.config.productionTip = false;

Vue.prototype.$bus = bus;


new Vue({
  router,
  i18n,
	store,
  render: h => h(App)
}).$mount('#app')